export default __webpack_public_path__ + "static/media/NFT.6a47918e.png";